import {Notification} from "element-ui";
import JenkinsNotification from "@/components/ui/websocket-notifications/JenkinsNotification.vue";
import AuthorizationNotification from "@/components/ui/websocket-notifications/AuthorizationNotification.vue";
import Vue from "vue";
import stompService from "@/services/stompService";
import store from "@/store";
import BaseNotification from "@/components/ui/websocket-notifications/BaseNotification.vue";

function renderNotificationComponent(Component, data) {
    const h = new Vue().$createElement
    return h(Component, {
        props: {
            messageData: data
        }
    })
}

export function closeWebsocketService() {
    stompService.disconnect()
}

export default function initConnectionToWebsocketService() {
    let initialSubscriptions = {
        "jenkins-notify": {
            destination: "/topic/jenkins-notify",
            callback: (msg) => {
                Notification({
                    title: '',
                    dangerouslyUseHTMLString: true,
                    message: renderNotificationComponent(JenkinsNotification, msg),
                    showClose: false,
                    duration: msg?.timeout * 1000,
                    customClass: "custom-websocket-notification"
                })
            }
        }
    }

    if(store.state.profile?.username) {
        initialSubscriptions["authorization-notify"] = {
            destination: `/topic/authorization-notify/${store.state.profile?.username}`,
            callback: (msg) => {
                Notification({
                    title: '',
                    dangerouslyUseHTMLString: true,
                    message: renderNotificationComponent(AuthorizationNotification, msg),
                    showClose: false,
                    duration: msg?.timeout * 1000,
                    customClass: "custom-websocket-notification authorization-notification"
                });
            }
        }

        initialSubscriptions["notification-notify"] = {
            destination: `/topic/notification-notify/${store.state.profile?.username}`,
            callback: (msg) => {
                Notification({
                    title: '',
                    dangerouslyUseHTMLString: true,
                    message: renderNotificationComponent(BaseNotification, msg),
                    showClose: true,
                    duration: msg?.timeout * 1000,
                    customClass: "custom-websocket-notification base-notification"
                });
            }
        }
    }

    return stompService.connect(initialSubscriptions)
}